import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Organization} from '../../../afb-graphql-api/models/organization';

@Component({
  selector: 'awair-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss']
})
export class OrganizationListComponent implements OnInit {

  @Input() activatedOrganizations: Organization[] = [];
  @Input() deactivatedOrganizations: Organization[] = [];
  @Input() pendingOrganizations: Organization[] = [];
  @Input() isLoading: boolean = false;
  @Input() isDialog: boolean = false;

  @Output() createOrganization: EventEmitter<void> = new EventEmitter<void>();
  @Output() enterOrganization: EventEmitter<Organization> = new EventEmitter<Organization>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  selectedOrganization: Organization;

  constructor() {
  }

  ngOnInit() {
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSelectOrganization(selectedOrganization: Organization): void {
    if (this.isLoading) {
      event.preventDefault();
    } else if (selectedOrganization) {
      this.selectedOrganization = {...selectedOrganization};
    }
  }

  onCreateOrganization(): void {
    this.createOrganization.emit();
  }

  onEnterOrganization(selectedOrganization: Organization): void {
    this.enterOrganization.emit(selectedOrganization);
  }
}
